export const DISCOUNT_TYPES = {
  PERCENT: 'percent',
  FLAT: 'flat',
} as const;
export type DiscountType = typeof DISCOUNT_TYPES[keyof typeof DISCOUNT_TYPES];
